import React from "react";
import { Link } from "react-router-dom";
import { EnvelopeSimple, Phone, MapPin, FacebookLogo, LockKey } from "@phosphor-icons/react";
import { useContent } from "../context/ContentContext";
import { Pikorua } from "./Pikorua";

export const Footer = () => {
  const { content, settings } = useContent();
  return (
    <footer className="relative bg-navy-dark text-white/80 overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 noise-overlay" />
      <Pikorua className="absolute -right-16 -bottom-16 w-80 h-80 text-gold opacity-[0.06]" stroke="#F2A900" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-heading text-2xl text-white font-semibold tracking-tight">Te Manawa</div>
          <p className="text-gold text-sm uppercase tracking-[0.2em] mt-1">The Heart of the North Island</p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">
            A Regional Association of Table Tennis New Zealand serving Taranaki, Bay of Plenty, Taupō and the central plateau.
          </p>
          {settings.facebook_enabled && content.facebook_url && (
            <a
              href={content.facebook_url}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook-link"
              className="mt-6 inline-flex items-center gap-2 text-white/80 hover:text-gold transition-colors"
            >
              <span className="grid place-items-center h-10 w-10 rounded-sm bg-white/5 border border-white/10">
                <FacebookLogo size={20} weight="fill" />
              </span>
              <span className="text-sm">Follow us on Facebook</span>
            </a>
          )}
        </div>

        <div>
          <h4 className="font-heading text-white text-lg mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors">About Us</Link></li>
            <li><Link to="/membership" className="hover:text-gold transition-colors">Membership</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
            <li><Link to="/policies" className="hover:text-gold transition-colors" data-testid="footer-policies-link">Policies</Link></li>
            {settings.events_enabled && <li><Link to="/events" className="hover:text-gold transition-colors">Events</Link></li>}
            {settings.news_enabled && <li><Link to="/news" className="hover:text-gold transition-colors">News</Link></li>}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white text-lg mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5">
              <EnvelopeSimple size={18} className="text-gold mt-0.5 shrink-0" />
              <a href={`mailto:${content.contact_email}`} className="hover:text-gold transition-colors break-all">{content.contact_email}</a>
            </li>
            <li className="flex items-start gap-2.5">
              <Phone size={18} className="text-gold mt-0.5 shrink-0" />
              <a href={`tel:${content.contact_phone}`} className="hover:text-gold transition-colors">{content.contact_phone}</a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin size={18} className="text-gold mt-0.5 shrink-0" />
              <span>{content.contact_postal}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        {settings.partner_enabled && content.partner_url && (
          <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex items-center justify-center gap-3 text-sm text-white/50 border-b border-white/5">
            <span>Proudly partnering with</span>
            <a href={content.partner_url} target="_blank" rel="noreferrer" data-testid="footer-partner-link" className="font-semibold text-[#FFE600] hover:underline">
              {content.partner_name || "Ray White New Plymouth"}
            </a>
          </div>
        )}
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Te Manawa Table Tennis Association. All rights reserved.</span>
          <Link
            to="/login"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-2 border border-white/20 text-white/80 px-4 py-2 rounded-sm text-xs font-semibold uppercase tracking-wide hover:border-gold hover:text-gold transition-colors"
          >
            <LockKey size={14} weight="fill" /> Admin Login
          </Link>
        </div>
      </div>
    </footer>
  );
};
